/* ==========================================================
   AANCHAL DESIGNERS
   Legend Product Card Interaction
   ========================================================== */

(() => {
  if (window.AanchalProductCardLoaded) return;
  window.AanchalProductCardLoaded = true;


  /* -------------------------------------------------------
     REMOVE FOCUS STATE FROM OTHER CARDS
     ------------------------------------------------------- */

  function clearFocusedCards(exceptCard = null) {
    document
      .querySelectorAll('[data-aanchal-card].is-product-focused')
      .forEach((card) => {
        if (card !== exceptCard) {
          card.classList.remove('is-product-focused');
          card.dataset.imageClicked = 'false';
        }
      });
  }


  /* -------------------------------------------------------
     PRODUCT IMAGE
     FIRST CLICK  = FOCUS / LIFT / SECOND IMAGE
     SECOND CLICK = PRODUCT PAGE
     ------------------------------------------------------- */

  document.addEventListener('click', (event) => {
    const mediaButton = event.target.closest(
      '[data-aanchal-product-image]'
    );

    if (!mediaButton) return;

    event.preventDefault();

    const card = mediaButton.closest('[data-aanchal-card]');

    if (!card) return;

    const productUrl =
      mediaButton.dataset.productUrl ||
      card.dataset.productUrl;

    const alreadyFocused =
      card.classList.contains('is-product-focused');


    /* SECOND CLICK */
    if (alreadyFocused) {
      if (productUrl) {
        window.location.href = productUrl;
      }

      return;
    }


    /* FIRST CLICK */
    clearFocusedCards(card);

    card.classList.add('is-product-focused');

    card.dataset.imageClicked = 'true';
  });


  /* -------------------------------------------------------
     CLICK OUTSIDE = RESET PRODUCT FOCUS
     ------------------------------------------------------- */

  document.addEventListener('click', (event) => {
    const clickedInsideCard =
      event.target.closest('[data-aanchal-card]');

    if (!clickedInsideCard) {
      clearFocusedCards();
    }
  });


  /* -------------------------------------------------------
     VARIANT / SIZE CHIP
     ------------------------------------------------------- */

  document.addEventListener('click', (event) => {
    const variantButton = event.target.closest(
      '[data-aanchal-variant]'
    );

    if (!variantButton) return;

    event.preventDefault();

    if (variantButton.disabled) return;

    const card =
      variantButton.closest('[data-aanchal-card]');

    if (!card) return;


    const variantInput =
      card.querySelector('[data-aanchal-variant-input]');

    const addButton =
      card.querySelector('[data-aanchal-atc]');

    const addText =
      card.querySelector('.aanchal-card__atc-text');


    card
      .querySelectorAll('[data-aanchal-variant]')
      .forEach((button) => {
        button.setAttribute('aria-pressed', 'false');
      });


    variantButton.setAttribute(
      'aria-pressed',
      'true'
    );


    if (variantInput) {
      variantInput.value =
        variantButton.dataset.variantId;

      variantInput.disabled = false;

      variantInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }


    if (addButton) {
      addButton.disabled = false;
    }


    if (addText) {
      addText.textContent = 'ADD TO BAG';
    }
  });


  /* -------------------------------------------------------
     MULTI OPTION SELECT
     ------------------------------------------------------- */

  document.addEventListener('change', (event) => {
    const select =
      event.target.closest(
        '[data-aanchal-variant-select]'
      );

    if (!select) return;

    const card =
      select.closest('[data-aanchal-card]');

    if (!card) return;


    const variantInput =
      card.querySelector(
        '[data-aanchal-variant-input]'
      );

    const addButton =
      card.querySelector(
        '[data-aanchal-atc]'
      );

    const addText =
      card.querySelector(
        '.aanchal-card__atc-text'
      );


    if (!select.value) {
      if (variantInput) {
        variantInput.disabled = true;
      }

      if (addText) {
        addText.textContent =
          'SELECT OPTION';
      }

      return;
    }


    if (variantInput) {
      variantInput.value =
        select.value;

      variantInput.disabled = false;

      variantInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }


    if (addButton) {
      addButton.disabled = false;
    }


    if (addText) {
      addText.textContent =
        'ADD TO BAG';
    }
  });


  /* -------------------------------------------------------
     ADD TO BAG
     IF NO VARIANT SELECTED → OPEN SIZE PANEL
     ------------------------------------------------------- */

  document.addEventListener(
    'click',
    (event) => {

      const addButton =
        event.target.closest(
          '[data-aanchal-atc]'
        );

      if (!addButton) return;

      if (addButton.disabled) return;


      const card =
        addButton.closest(
          '[data-aanchal-card]'
        );

      if (!card) return;


      const variantInput =
        card.querySelector(
          '[data-aanchal-variant-input]'
        );

      const variantPanel =
        card.querySelector(
          '[data-aanchal-variant-panel]'
        );


      /* Multi variant product
         but customer has not selected size */
      if (
        variantInput &&
        variantInput.disabled
      ) {
        event.preventDefault();

        if (variantPanel) {
          variantPanel.classList.add(
            'is-open'
          );


          const firstAvailable =
            variantPanel.querySelector(
              '[data-aanchal-variant]:not([disabled]), [data-aanchal-variant-select]'
            );


          if (firstAvailable) {
            window.setTimeout(() => {
              firstAvailable.focus({
                preventScroll: true
              });
            }, 250);
          }
        }
      }

    },
    true
  );


  /* -------------------------------------------------------
     ESCAPE CLOSES FOCUS
     ------------------------------------------------------- */

  document.addEventListener(
    'keydown',
    (event) => {

      if (event.key === 'Escape') {
        clearFocusedCards();

        document
          .querySelectorAll(
            '[data-aanchal-variant-panel].is-open'
          )
          .forEach((panel) => {
            panel.classList.remove(
              'is-open'
            );
          });
      }

    }
  );

})();